import styled from 'styled-components'
import { captionSmallCss } from 'components/typography/paragraph'
import { UnorderedList } from 'components/list'

export const Day = styled.section`
    &:not(:last-child) {
        margin-block-end: 40px;
    }
`

export const DayHeader = styled.h2`
    ${captionSmallCss}
`

export const LogEntries = styled(UnorderedList)`
    display: flex;
    flex-direction: column;
`